import Assets from 'app/configs/assetConfigs'

export const CUSTOM = 'custom'
export const DO_NOT_RETYE = 'doNotRetry'

export const retryOptions = [
  {
    id: 1,
    value: CUSTOM,
    label: 'manageChannels.selectorRetry.custom.lable',
  },
  {
    id: 2,
    value: DO_NOT_RETYE,
    label: 'manageChannels.selectorRetry.doNotRetry.lable',
  },
]

export const retryUnitOptions = [
  {
    id: 1,
    value: 'minute',
    label: 'manageChannels.selectorRetry.custom.until.minute.lable',
  },
  {
    id: 2,
    value: 'hour',
    label: 'manageChannels.selectorRetry.custom.until.hour.lable',
  },
  {
    id: 3,
    value: 'day',
    label: 'manageChannels.selectorRetry.custom.until.day.lable',
  },
  {
    id: 4,
    value: 'week',
    label: 'manageChannels.selectorRetry.custom.until.week.lable',
  },
]

export const NOTI_PRIORITY_HIGH_ITEM = {
  id: 'important',
  imgSrc: Assets.notiPriority.important,
  labelId: 'createNotification.dialog.notiPriority.high',
  color: 'blue',
  formLableStartTime: 'callableImportantTimeWindowStart',
  formLableEndTime: 'callableImportantTimeWindowEnd',
}

export const NOTI_PRIORITY_LOW_ITEM = {
  id: 'information',
  imgSrc: Assets.notiPriority.information,
  labelId: 'createNotification.dialog.notiPriority.low',
  color: 'green-dark',
  formLableStartTime: 'callableInformationTimeWindowStart',
  formLableEndTime: 'callableInformationTimeWindowEnd',
}

export const NOTI_PRIORITY_URGENT_ITEM = {
  id: 'urgent',
  imgSrc: Assets.notiPriority.urgent,
  labelId: 'createNotification.dialog.notiPriority.urgent',
  color: 'orange',
  formLableStartTime: 'callableUrgentTimeWindowStart',
  formLableEndTime: 'callableUrgentTimeWindowEnd',
}

export const NOTI_PRIORITY_EMERGENCY_ITEM = {
  id: 'emergency',
  imgSrc: Assets.notiPriority.emergency,
  labelId: 'createNotification.dialog.notiPriority.emergency',
  color: 'red',
  formLableStartTime: 'callableEmergencyTimeWindowStart',
  formLableEndTime: 'callableEmergencyTimeWindowEnd',
}

export const priorityList = (emergency) => {
  return emergency
    ? [
        NOTI_PRIORITY_LOW_ITEM,
        NOTI_PRIORITY_HIGH_ITEM,
        NOTI_PRIORITY_URGENT_ITEM,
        NOTI_PRIORITY_EMERGENCY_ITEM,
      ]
    : [
        NOTI_PRIORITY_LOW_ITEM,
        NOTI_PRIORITY_HIGH_ITEM,
        NOTI_PRIORITY_URGENT_ITEM,
      ]
}

export const ALL_DAY = 'all day'
